// Mirrors the BrowserRouter basename in index.tsx so the login link resolves correctly when the app
// is hosted under /partners/ (or a feature deploy override). AppCrash sits above the router, so we
// can't use <Link> here.
const loginHref = `${import.meta.env.VITE_HOMEPAGE ? `/${import.meta.env.VITE_HOMEPAGE}/` : '/partners/'}login`;

const AppCrash = () => (
    <div className="flex min-h-dvh items-center justify-center bg-gray-50 p-8">
        <div className="max-w-[480px] text-center">
            <p className="text-lg font-semibold">Something went wrong</p>
            <p className="mb-12 mt-6 text-lg">
                We're sorry — an unexpected error occurred. Please try refreshing the page.
            </p>
            <div className="flex items-center justify-center gap-6">
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="text-lg font-semibold underline"
                >
                    Refresh page
                </button>
                <a href={loginHref} className="text-lg font-semibold underline">
                    Go to login
                </a>
            </div>
        </div>
    </div>
);

export default AppCrash;
